import { GET } from "../../API/get";
import { POST } from "../../API/post";
import { PUT } from "../../API/put";
import { getUserInfo } from "../../storage";

export const fetchFtmRequest = async (request_id) => {
    const response = await GET(`v3/ftm-requests/${request_id}`);
    return response?.status === "Success" ? response : null;
};

const updateMaterialsStatus = async ({job_id, ftm_request_id, is_accept}) => {
    const response = await PUT("is-accept-more-time-and-materials", {
        job_id: job_id,
        ftm_request_id: ftm_request_id,
        is_accept: is_accept
    });

    return response?.status === "Success" ? response : null;
}

export const approvedFtmRequest = async ({job_id, ftm_request_id}) => {
    const response = await updateMaterialsStatus({job_id, ftm_request_id, is_accept: 1});
    return response?.status === "Success" ? response : null;
}

export const rejectFtmRequest = async ({job_id, ftm_request_id}) => {
    const response = await updateMaterialsStatus({job_id, ftm_request_id, is_accept: -1});
    return response?.status === "Success" ? response : null;
}

export const approveAnotherDate = async ({job_id, request_id, description}) => {
    const response = await POST("job/approve/for/another/date",{
        job_id, 
        request_id, 
        description
    });

    return response?.status === "Success" ? response : null;
}

export const markRequestIsUndecidede = async ({request_id}) => {
    const response = await PUT("job/undecided/requests",{
        request_id
    });

    return response?.status === "Success" ? response : null;
};

export const fetchPendingUndecidedRequest = async (page) => {
    const userInfo = getUserInfo();

    const response = await GET(`pending-undecided/requests/${userInfo.customer_id}/${page}`);
    return response?.status === "Success" ? response : null;
};